import React from "react";
import { Link } from "react-router-dom";
import translations from "../../../text/get-started-translations.json";
import language from '../../../utils/LanguageSettings';

interface ChannelCategoryProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const ChannelCategory: React.FC<ChannelCategoryProps> = ({ activeCategory, onCategoryChange }) => {
  const pageTranslations = translations[language];

  const handleCategoryClick = (category: string) => {
    onCategoryChange(category);
  };

  return (
    <div className="channel-category row">
      <div className="channel-type">
        <Link
          to="#channel"
          className={`text-16 ${activeCategory === "channel" ? "active" : ""}`}
          data-target="channel"
          onClick={() => handleCategoryClick("channel")}
        >
          {pageTranslations.Channel}
        </Link>
        <Link
          to="#on-demand"
          className={`text-16 ${activeCategory === "on-demand" ? "active" : ""}`}
          data-target="on-demand"
          onClick={() => handleCategoryClick("on-demand")}
        >
          {pageTranslations.OnDemand}
        </Link>
      </div>
    </div>
  );
};

export default ChannelCategory;